// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"617c5114","595":"db5b05b3"}[chunkId] + ".chunk.css";
};